import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet.heat";

// Pattern standard react-leaflet pour un plugin non-React (leaflet.heat n'a pas de wrapper
// officiel) : on récupère l'instance de carte via useMap() et on ajoute/retire la couche
// impérativement dans un effet.
function HeatLayer({ points, options }) {
  const map = useMap();

  useEffect(() => {
    if (!points || points.length === 0) return undefined;

    const layer = L.heatLayer(
      points.map((p) => [p.lat, p.lng, p.intensity ?? 0.5]),
      { radius: 20, blur: 25, maxZoom: 17, ...options }
    );
    layer.addTo(map);

    return () => {
      map.removeLayer(layer);
    };
  }, [map, points, options]);

  return null;
}

export default HeatLayer;
